import { createAsyncAction } from 'redux-promise-middleware-actions';
import api from '../Api/apiIS';
import { getActionTypesResult } from '../utils';

export const licensesConstants = {
    LICENSES_LOADED: 'LICENSES_LOADED',
    LICENSES_CLEARED: 'LICENSES_CLEARED',
    LICENSE_CREATED: 'LICENSE_CREATED',
    LICENSE_UPDATED: 'LICENSE_UPDATED',
    LICENSE_DELETED: 'LICENSE_DELETED',
    LICENSE_ASSIGNED: 'LICENSE_ASSIGNED',
    LICENSE_ASSIGNEE_USERS: 'LICENSES_ASSIGNEE_USERS',
    LICENSE_ASSIGNEE_DEVICES: 'LICENSES_ASSIGNEE_DEVICES',
    LICENSE_ASSIGNEE_INFRASTRUCTURE_UNITS: 'LICENSE_ASSIGNEE_INFRASTRUCTURE_UNITS',
    LICENSE_UNASSIGNED: 'LICENSE_UNASSIGNED',
    MANUFACTURER_SAVED: 'MANUFACTURER_SAVED',
    LICENSE_REVIEW_CLEARED: 'LICENSE_REVIEW_CLEARED',
    LICENSE_SUMMARY: 'LICENSE_SUMMARY',
    LICENSE_REVIEW_UPDATED: 'LICENSE_REVIEW_UPDATED',
};

export const licensesFulfilledConstants = getActionTypesResult(licensesConstants, '_FULFILLED');
export const licensesPendingConstants = getActionTypesResult(licensesConstants, '_PENDING');
export const licensesRejectedConstants = getActionTypesResult(licensesConstants, '_REJECTED');

export const clearLicenses = () => ({
    type: licensesConstants.LICENSES_CLEARED
});

export const clearReview = () => ({
    type: licensesConstants.LICENSE_REVIEW_CLEARED
});

export const fetchLicenses = createAsyncAction(licensesConstants.LICENSES_LOADED, query =>
    api.get('licenses', { params: query, paramsSerializer: { indexes: null } }).then(res => res.data));

export const fetchLicenseUserAssignment = createAsyncAction(licensesConstants.LICENSE_ASSIGNED, query =>
    api.get(`/licenseUserAssignment`, { params: query, paramsSerializer: { indexes: null } }).then(res => res.data)
);

export const fetchLicenseVMAssignment = createAsyncAction(licensesConstants.LICENSE_ASSIGNED, query =>
    api.get(`/licenseVirtualMachineAssignment`, { params: query, paramsSerializer: { indexes: null } }).then(res => res.data)
);

export const fetchLicenseIUAssignment = createAsyncAction(licensesConstants.LICENSE_ASSIGNED, query =>
    api.get(`/licenseDeviceAssignment`, { params: query, paramsSerializer: { indexes: null } }).then(res => res.data)
);

export const saveLicense = createAsyncAction(licensesConstants.LICENSE_CREATED, device =>
    api.post('licenses/license', device).then(res => res.data)
);

export const updateLicense = createAsyncAction(licensesConstants.LICENSE_UPDATED, (deviceId, device) =>
    api.put('licenses/license', device).then(res => res.data)
);

export const getLicenseUserAssignment = createAsyncAction(licensesConstants.LICENSE_ASSIGNEE_USERS, licenseId =>
    api.get(`licenseUserAssignment?LicenseId=${licenseId}`).then(res => res.data)
);

export const getLicenseVirtualMachineAssignment =
    createAsyncAction(licensesConstants.LICENSE_ASSIGNEE_DEVICES, licenseId =>
        api.get(`licenseVirtualMachineAssignment/?LicenseId=${licenseId}`).then(res => res.data)
    );

export const getLicenseInfrastructureUnitAssignment =
    createAsyncAction(licensesConstants.LICENSE_ASSIGNEE_INFRASTRUCTURE_UNITS, licenseId =>
        api.get(`licenseDeviceAssignment/?LicenseId=${licenseId}`).then(res => res.data)
    );

export const unassignLicenseFromUser = createAsyncAction(licensesConstants.LICENSE_UNASSIGNED, assignmentId =>
    api.delete(`licenseUserAssignment/${assignmentId}`).then(res => res.data)
);

export const unassignLicenseFromVirtualMachine = createAsyncAction(licensesConstants.LICENSE_UNASSIGNED, assignmentId =>
    api.delete(`licenseVirtualMachineAssignment/${assignmentId}`).then(res => res.data)
);

export const unassignLicenseFromInfrastructureUnit =
    createAsyncAction(licensesConstants.LICENSE_UNASSIGNED, assignmentId =>
        api.delete(`licenseDeviceAssignment/${assignmentId}`).then(res => res.data)
    );

export const licenseUserAssignment = createAsyncAction(licensesConstants.LICENSE_ASSIGNED, data =>
    api.post(`/licenseUserAssignment`, data).then(res => res.data)
);

export const licenseVirtualMachineAssignments = createAsyncAction(licensesConstants.LICENSE_ASSIGNED, data =>
    api.post(`/licenseVirtualMachineAssignment`, data).then(res => res.data)
);

export const licenseInfrastructureUnitAssignments = createAsyncAction(licensesConstants.LICENSE_ASSIGNED, data =>
    api.post(`licenseDeviceAssignment`, data).then(res => res.data)
);

export const saveManufacturer = createAsyncAction(licensesConstants.MANUFACTURER_SAVED, input =>
    api.post('licenseManufacturer', input).then(res => res.data)
);

export const deleteLicense = createAsyncAction(licensesConstants.LICENSE_DELETED, data =>
    api.delete('licenses/license', { data }).then(res => res.data)
);

export const getLicenseUserSummary = createAsyncAction(licensesConstants.LICENSE_SUMMARY, licenseId =>
    api.get(`licenseUserAssignment/${licenseId}/licenseSummary`).then(res => res.data)
);

export const getLicenseVirtualMachineSummary = createAsyncAction(licensesConstants.LICENSE_SUMMARY, licenseId =>
    api.get(`licenseVirtualMachineAssignment/${licenseId}/licenseSummary`).then(res => res.data)
);

export const getLicenseInfrastructureUnitSummary = createAsyncAction(
    licensesConstants.LICENSE_SUMMARY, licenseId =>
        api.get(`licenseDeviceAssignment/${licenseId}/licenseSummary`).then(res => res.data)
);

export const updateLicenseUserAssignment = createAsyncAction(licensesConstants.LICENSE_REVIEW_UPDATED, data =>
    api.put(`licenseUserAssignment`, data).then(res => res.data));

export const updateLicenseVirtualMachineAssignment =
    createAsyncAction(licensesConstants.LICENSE_REVIEW_UPDATED, data =>
        api.put(`licenseVirtualMachineAssignment`, data).then(res => res.data)
    );

export const updateLicenseInfrastructureUnitAssignment =
    createAsyncAction(licensesConstants.LICENSE_REVIEW_UPDATED, data =>
        api.put(`licenseDeviceAssignment`, data).then(res => res.data)
    );
